import { render, staticRenderFns } from "./licationGain.vue?vue&type=template&id=60f2bb4a"
import script from "./licationGain.vue?vue&type=script&lang=js"
export * from "./licationGain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports